import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { initClientSentry, SentryErrorBoundary } from './lib/sentry.js';
import './index.css';

initClientSentry();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <SentryErrorBoundary fallback={<ErrorFallback />} showDialog={false}>
      <App />
    </SentryErrorBoundary>
  </StrictMode>,
);

function ErrorFallback(): JSX.Element {
  return (
    <main className="mx-auto max-w-xl p-8 text-center">
      <h1 className="text-2xl font-semibold text-slate-900">Something went wrong</h1>
      <p className="mt-2 text-slate-600">
        We&apos;ve been notified. Please refresh the page or try again shortly.
      </p>
    </main>
  );
}
